import React from 'react';
import ConstTooltip from '../../../common/mixTable/tooltip/Const';
const listColumn = [
  {
    key: 'ticker',
    textAlign: 'left',
    isIconGraph: true,
    width: '70px',
    isString: true,
  },
  {
    key: 'alertName',
    textAlign: 'left',
    typeTooltip: ConstTooltip.typeHover.hoverAlertSystem,
    keyOrgCode: 'organCode',
    format: (text, item) => {
      return (
        <div
          title={`${item.alertGroupName}/${item.alertName}`}
          className="text-truncate"
          style={{ maxWidth: 150 }}
        >
          {item.alertGroupName}/{item.alertName}
        </div>
      );
    },
    isDisSort: true,
  },
  {
    key: 'activate',
    textAlign: 'center',
    isToggleSwitch: true,
    keyIsActive: 'isActive',
    width: '64px',
    isDisSort: true,
  },
  {
    key: 'action',
    textAlign: 'center',
    isAction: true,
    width: '64px',
    isDisSort: true,
  },
];

export default {
  listColumn,
  idAlertPersonal: 'idAlertPersonal',
  idCondition: 'conditionId',
  defaultOption: 'VolPriceIncrease',
  maxRowData: 30,
};
